export function useMerchantPolicySettings(checkoutSession) {
  const policySettings = checkoutSession.policySettingsData;
  const displayAcknowledgementCheckbox = !!policySettings && policySettings.customPolicyEnabled && policySettings.acknowledgementRequired;
  return {
    policySettings,
    displayAcknowledgementCheckbox
  };
}